export default __webpack_public_path__ + "static/media/drp-navy-spinner.f33d91df.gif";